export default "/static/9137b696cb8b9b19.svg"